import {
    HORIZON_Y,
    GROUND_Y,
    CENTER_X,
    TRACK_WIDTH_AT_HORIZON,
    LINE_SPACING_METERS,
    getScale,
    getSpeedMultiplier,
    getSpreadFactor
} from './constants';

export default class TrackLine {
    y: number;

    constructor(y: number) {
        this.y = y;
    }

    getScale(): number {
        return getScale(this.y);
    }

    update(deltaTime: number, skierSpeed: number) {
        const scale = this.getScale();
        const speedMultiplier = getSpeedMultiplier(scale);
        const descentSpeed = skierSpeed * 10 * speedMultiplier;
        this.y += descentSpeed * deltaTime / 1000;
    }

    isOffScreen(): boolean {
        return this.y > 450;
    }

    draw(ctx: CanvasRenderingContext2D, zoom: number) {
        const scale = this.getScale();
        if (scale < 0.2) return;

        const alpha = Math.min(0.3, scale * 0.25);
        const thickness = scale * 4;

        const spreadFactor = getSpreadFactor(scale);
        const width = TRACK_WIDTH_AT_HORIZON * spreadFactor;

        ctx.save();
        ctx.fillStyle = `rgba(200, 220, 255, ${alpha})`;
        ctx.fillRect(
            zoom * (CENTER_X - width / 2),
            zoom * (this.y - thickness / 2),
            zoom * width,
            zoom * thickness
        );
        ctx.restore();
    }
}

// Track line state management
let trackLines: TrackLine[] = [];
let lastLineDistance = 0;

export function updateTrackLines(deltaTime: number, skierSpeed: number, distanceTraveled: number) {
    // Spawn track lines based on distance traveled
    while (distanceTraveled >= lastLineDistance + LINE_SPACING_METERS) {
        lastLineDistance += LINE_SPACING_METERS;
        trackLines.push(new TrackLine(HORIZON_Y));
    }

    // Update track lines
    for (const line of trackLines) {
        line.update(deltaTime, skierSpeed);
    }

    // Remove off-screen track lines
    trackLines = trackLines.filter(l => !l.isOffScreen());
}

export function drawTrackLines(ctx: CanvasRenderingContext2D, zoom: number) {
    for (const line of trackLines) {
        line.draw(ctx, zoom);
    }
}

export function resetTrackLines() {
    trackLines = [];
    lastLineDistance = 0;
}

export function initializeTrackLines() {
    // Use variable step: small at top (dense), large at bottom (sparse)
    let y = HORIZON_Y + 10;
    while (y < GROUND_Y - 30) {
        const progress = (y - HORIZON_Y) / (GROUND_Y - HORIZON_Y);
        // Step increases with progress: 15px at top, 60px at bottom
        const step = 5 + progress * 150;

        const line = new TrackLine(HORIZON_Y);
        line.y = y;
        trackLines.push(line);

        y += step;
    }
}
